export interface ParsedCsv {
  headers: string[]
  rows: string[][]
}

export interface CsvRowObject {
  [key: string]: string
}

export function parseSemrushCsv(csv: string): ParsedCsv {
  const lines = csv.split(/\r?\n/).filter((l) => l.trim().length > 0)
  const rows: string[][] = []
  for (const line of lines) {
    const fields: string[] = []
    let current = ''
    let inQuotes = false
    for (let i = 0; i < line.length; i++) {
      const ch = line[i]
      const next = line[i + 1]
      if (ch === '"') {
        if (inQuotes && next === '"') {
          current += '"'
          i++
        } else {
          inQuotes = !inQuotes
        }
      } else if (ch === ';' && !inQuotes) {
        fields.push(current)
        current = ''
      } else {
        current += ch
      }
    }
    fields.push(current)
    rows.push(fields)
  }
  const headers = rows.length > 0 ? rows[0].map((h) => h.trim()) : []
  const dataRows = rows.length > 1 ? rows.slice(1) : []
  return { headers, rows: dataRows }
}

export function rowsToObjects(headers: string[], rows: string[][]): CsvRowObject[] {
  const lower = headers.map((h) => h.toLowerCase())
  return rows.map((r) => {
    const obj: CsvRowObject = {}
    for (let i = 0; i < lower.length; i++) {
      obj[lower[i]] = r[i] ?? ''
    }
    return obj
  })
}

export function headerIndex(headers: string[], aliases: string[]): number {
  const lower = headers.map((h) => h.toLowerCase())
  for (const a of aliases) {
    const i = lower.indexOf(a.toLowerCase())
    if (i !== -1) return i
  }
  return -1
}

export function coerceNumber(val: string | undefined): number {
  if (!val) return 0
  const cleaned = val.replace(/[,\s]/g, '')
  const n = Number(cleaned)
  return Number.isFinite(n) ? n : 0
}
